export default {
  state: {
    // 当前全局路由列表
    routerList: [],

    // 路由历史
    routerHistory: [],
  },
  mutations: {
    // 设置routerList
    setRouterList: (state: any, routerList: any[]) => {
      state.routerList = routerList;
    },

    // 初始化历史记录
    initRouterHistory(state: any, routerHistory: any) {
      state.routerHistory = routerHistory;
    },

    // 设置历史路径
    setRouterHistory: (state: any, router: any) => {
      if (router.name !== undefined && router.meta.title !== undefined) {
        // 查找是否有相同数据 es6 array.findIndex方法
        const index = state.routerHistory.findIndex(
          (element: any) => element.name === router.name
        );
        if (index > -1) {
          // 有相同数据则先删除相同数据
          state.routerHistory.splice(index, 1);
        }
        state.routerHistory.push({
          title: router.meta.title,
          name: router.name,
          path: router.path,
        });
      }

      // 限定大小
      if (state.routerHistory.length > 10) {
        state.routerHistory.shift();
      }
    },

    // 删除某条历史路径
    removeRouterHistory: (state: any, index: number) => {
      state.routerHistory.splice(index, 1);
    },

    // 清空数据
    resetState: (state: any) => {
      state.routerList = [];
      state.routerHistory = [];
    },
  },
};
